export default __webpack_public_path__ + "static/media/clipboard-icon.f76c0a91.svg";